import * as React from 'react';
import { visualize, story, snap } from 'storybook-snapper';
import { SkeletonLine } from './SkeletonLine';
import { st, classes } from './SkeletonLine.visual.st.css';

visualize('SkeletonLine', () => {
  story('simple', () => {
    snap('default', <SkeletonLine className={classes.pausedAnimation}/>);
  });

  story('overrides', () => {
    snap('default', <SkeletonLine className={st(classes.defaultStylesOverride, classes.pausedAnimation)} />);
  });

  story('with wst variables', () => {
    snap('default',()=>{
      const style = {
        '--wst-paragraph-2-color-rgb': '0,100,180',
      } as React.CSSProperties;
      return  <div style={style}><SkeletonLine className={classes.pausedAnimation}/></div>;
    });
  });
});


